import { ReactNode } from 'react';
import { FormEllipsis } from '@components/form';
import { TooltipWrapper } from '@components/tooltip/Tooltip';
import { Avatar, AvatarImage, AvatarBadgesContainer } from './Avatar.style';

export interface AvatarBadgesProps {
    data: AvatarBadgeProps[];
    hasLabel?: boolean;
}

export interface AvatarBadgeProps {
    label: string;
    hoverLabel: string;
    image?: string | null;
    icon?: ReactNode;
    variant?: 'primary' | 'neutral';
}

function AvatarBadge({ item, idx }: { item: AvatarBadgeProps; idx: number }) {
    return (
        <TooltipWrapper label={item.hoverLabel}>
            <Avatar $idx={idx} $variant={item.variant}>
                {item.image ? <AvatarImage src={item.image} alt="avatar" /> : item.icon ?? item.label}
            </Avatar>
        </TooltipWrapper>
    );
}

export const AvatarBadges = (props: AvatarBadgesProps) => {
    const { data, hasLabel } = props;
    const text = data.map((item) => item.hoverLabel).join(', ');

    return (
        <AvatarBadgesContainer>
            {data.map((item, idx) => {
                return <AvatarBadge key={idx} idx={idx} item={item} />;
            })}
            {hasLabel ? <FormEllipsis size="small">{text}</FormEllipsis> : null}
        </AvatarBadgesContainer>
    );
};
